import { Intent } from "@blueprintjs/core";
import { ButtonWithDialog } from "@focus/focusUI";
import { useState } from "react";
import { useUserController } from "../../hooks/useUserController";
import { UserForm } from "./UserForm";

export const CreateUserButton = () => {
  const { addUser } = useUserController();

  const [isFormValid, setIsFormValid] = useState(false);

  const emptyUser = {
    username: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    roleGroups: [],
    enabled: false,
    email: "",
    organizations: [],
  };

  return (
    <ButtonWithDialog
      minimal
      icon="new-person"
      tooltipText="New user"
      intent={Intent.NONE}
      defaultContent={emptyUser}
      onAccept={(newUser) => addUser(newUser)}
      form={({ content, onUpdate }) => (
        <UserForm
          content={content}
          onUpdate={onUpdate}
          onValidityChange={setIsFormValid}
          readOnly={false}
        />
      )}
      disableAccept={!isFormValid}
    />
  );
};
